"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const namespaces_1 = require("../namespaces");
const partialCollectionIteratorFactory_1 = require("./partialCollectionIteratorFactory");
/**
 * Provides factory methods for strongly typed resources.
 * @const
 * @type {IDictionary<InstanceFactory>}
 */
exports.factories = {};
exports.factories[namespaces_1.hydra.ApiDocumentation] = (resource, client) => {
    const target = resource;
    target.getEntryPoint = () => client.getResource(target.entryPoint);
    return resource;
};
exports.factories[namespaces_1.hydra.Collection] = partialCollectionIteratorFactory_1.partialCollectionIteratorFactory;
exports.factories.any = resource => {
    if (!!resource.displayName) {
        Object.defineProperty(resource, "displayName", { get: () => this.title || this.label || "" });
        Object.defineProperty(resource, "textDescription", { get: () => this.description || this.comments || "" });
    }
    return resource;
};
//# sourceMappingURL=factories.js.map